import { create } from 'zustand';

type AuthState = {
  token: string | null;
  user: { id: string; email: string; displayName: string } | null;
  setAuth: (token: string, user: AuthState['user']) => void;
  logout: () => void;
};

const STORAGE_KEY = 'pannini.auth';

function load(): { token: string | null; user: AuthState['user'] } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { token: null, user: null };
    return JSON.parse(raw);
  } catch {
    return { token: null, user: null };
  }
}

export const useAuth = create<AuthState>((set) => {
  const initial = load();
  return {
    token: initial.token,
    user: initial.user,
    setAuth: (token, user) => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, user }));
      set({ token, user });
    },
    logout: () => {
      localStorage.removeItem(STORAGE_KEY);
      set({ token: null, user: null });
    },
  };
});
